/** Loading placeholder mirroring the song detail page layout. */
export function SongDetailSkeleton() {
  return (
    <div className="flex flex-col gap-8">
      {/* Back nav skeleton */}
      <div className="flex items-center justify-between">
        <div className="h-4 w-24 animate-pulse rounded bg-bg-tertiary" />
        <div className="h-8 w-16 animate-pulse rounded bg-bg-tertiary" />
      </div>
      {/* Title skeleton */}
      <div className="space-y-3">
        <div className="h-8 w-2/3 animate-pulse rounded bg-bg-tertiary" />
        <div className="h-4 w-32 animate-pulse rounded bg-bg-tertiary" />
      </div>
      {/* Recordings section skeleton */}
      <div className="space-y-4">
        <div className="h-4 w-24 animate-pulse rounded bg-bg-tertiary" />
        <div className="h-16 w-full animate-pulse rounded bg-bg-tertiary" />
      </div>
      {/* Notes section skeleton */}
      <div className="space-y-4">
        <div className="h-4 w-16 animate-pulse rounded bg-bg-tertiary" />
        <div className="h-48 w-full animate-pulse rounded bg-bg-tertiary" />
      </div>
      {/* Loading text for screen readers */}
      <span className="sr-only">Loading song...</span>
    </div>
  );
}
